require.context("./images", true);
import "./inventory.scss";
